/**
 * Constantes del dominio de Talonarios: permiso, tamaño de rango y los mensajes
 * legibles por `error_code` de la API.
 *
 * El gating de la UI usa el MISMO permiso que exige la API y el SSR
 * (`manage_talonarios`, ver `progress/explore_talonarios_api.md`, §1). El tamaño
 * de talonario es fijo (50 números, §3.A). Los mensajes traducen los `error_code`
 * del backend (§4) a texto legible en español.
 */

/** Permiso que gobierna todo el dominio (igual que la API y el menú del SSR). */
export const MANAGE_TALONARIOS_PERMISSION = "manage_talonarios";

/** Tamaño exacto de un talonario (números por rango); lo exige el backend. */
export const TALONARIO_SIZE = 50;

/**
 * Diccionario de mensajes legibles por `error_code` de la API de talonarios
 * (`progress/explore_talonarios_api.md`, §4). Si llega un código no listado, se
 * cae al `message` del propio `ApiError` (que el backend ya da en español).
 */
export const TALONARIO_ERROR_MESSAGE: Record<string, string> = {
  worker_required: "El trabajador es obligatorio.",
  invalid_range: "Los números del talonario deben ser válidos.",
  invalid_range_size: "El talonario debe tener exactamente 50 números.",
  // `assign_failed` NO se mapea aquí a propósito: el backend devuelve el detalle
  // del solapamiento ("El rango X-Y se solapa con el talonario de Z"), más útil
  // que un texto genérico. Cae al `message` del `ApiError`.
  invalid_number: "Número de talonario inválido.",
  number_out_of_range: "El número está fuera del rango del talonario.",
  number_in_use: "Ya existe una orden real con ese número.",
  already_marked: "El número ya está marcado.",
  not_found: "Recurso no encontrado.",
  forbidden: "No tienes permiso para gestionar talonarios.",
  bad_request: "Falta seleccionar la sede.",
  invalid_date: "Formato de fecha inválido (usa DD/MM/AAAA o AAAA-MM-DD).",
  internal_server_error: "Ocurrió un error en el servidor.",
};

/**
 * Etiquetas legibles del estado de un número del grid (UI en español). El color
 * lo decide el componente del grid; aquí solo el texto accesible.
 */
export const GRID_STATUS_LABEL = {
  order: "Ocupado por orden",
  marked: "Marcado manualmente",
  available: "Disponible",
} as const;
